import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { GameCard } from "./GameCard";
import { makeT } from "../../lib/i18n";

// A worked example of combining the four dealt cards into one offer ("La Isla que No Viste").
const EX = [
  { slot: "PARTNER", es: "Un operador de turismo receptivo", en: "An inbound tour operator" },
  { slot: "PAIN", es: "Hoteles vacíos en temporada baja", en: "Empty hotels in the low season" },
  { slot: "TRIBE", es: "Nómadas digitales que trabajan viajando", en: "Digital nomads who work while travelling" },
  { slot: "TOOL", es: "Un pase mensual todo-incluido", en: "An all-inclusive monthly pass" },
];

export function ExampleOffer({ lang = "es", compact = false }) {
  const t = makeT(lang);
  const w = compact ? 84 : 104;
  return (
    <div className="w-full">
      <div className="text-[0.65rem] font-bold tracking-[0.16em] text-dig-blue mb-2">{t("EJEMPLO · CÓMO SE JUEGA", "EXAMPLE · HOW TO PLAY")}</div>
      <p className="text-sm text-dig-harbour/70 mb-4">{t("Combina tus cuatro cartas en una sola oferta. Así:", "Combine your four cards into one offer. Like this:")}</p>
      <div className="flex flex-wrap items-center justify-center gap-2 mb-4">
        {EX.map((c, i) => (
          <motion.div key={c.slot} initial={{ opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.08 }}>
            <GameCard category={c.slot} code={`EX-${i + 1}`} es={c.es} en={c.en} width={w} lang={lang} />
          </motion.div>
        ))}
      </div>
      <div className="flex items-center justify-center gap-2 text-dig-harbour/40 mb-3"><ArrowRight size={18} /></div>
      <div className="bg-dig-yellow-tint border border-dig-yellow/40 rounded-2xl p-4 text-center">
        <div className="font-black text-lg">{t("La Isla que No Viste", "The Island You Never Saw")}</div>
        <p className="text-sm text-dig-harbour/70 mt-1">
          {t(
            "Un pase mensual para nómadas digitales que llena los hoteles del operador en temporada baja.",
            "A monthly pass for digital nomads that fills the operator's hotels in the low season."
          )}
        </p>
      </div>
    </div>
  );
}
